<template>
  <div class="extra_info_area neg_topMargin">
    <md-card>
      <md-card-header><md-icon>account_balance</md-icon>Curabitur Eleifend</md-card-header>
      <md-card-content>
        <h4>Praesent venenatis</h4>
        <p>Sed et placerat lorem. Integer nec accumsan tortor. Nullam at eleifend urna. Donec pulvinar quam ligula, id tincidunt orci rutrum ut.</p>
        <h4>Quisque ut ex ligula</h4>
        <p>Nullam vel pulvinar nisl. Morbi aliquam scelerisque congue. Quisque ut ex ligula. Nunc eu nunc in nulla pulvinar efficitur non id leo. Praesent eget sem eget eros mattis malesuada.</p>
      </md-card-content>
    </md-card>
    <md-card>
      <md-card-header><md-icon>vertical_split</md-icon>Vivamus Hendrerit</md-card-header>
      <md-card-content>
        <h4>Fusce feugiat mollis</h4>
        <p>Sed et placerat lorem. Integer nec accumsan tortor. Nullam at eleifend urna. Donec pulvinar quam ligula, id tincidunt orci rutrum ut.</p>
        <h4>Praesent eget sem eget</h4>
        <p>Nullam vel pulvinar nisl. Morbi aliquam scelerisque congue. Quisque ut ex ligula. Nunc eu nunc in nulla pulvinar efficitur non id leo. Praesent eget sem eget eros mattis malesuada.</p>
      </md-card-content>
    </md-card>
    <md-card>
      <md-card-header><md-icon>article</md-icon>Gravida Pharetra</md-card-header>
      <md-card-content>
        <h4>Aenean at eros mollis</h4>
        <p>Sed et placerat lorem. Integer nec accumsan tortor. Nullam at eleifend urna. Donec pulvinar quam ligula, id tincidunt orci rutrum ut.</p>
        <h4>Quisque ut ex ligula</h4>
        <p>Nullam vel pulvinar nisl. Morbi aliquam scelerisque congue. Quisque ut ex ligula. Nunc eu nunc in nulla pulvinar efficitur non id leo. Praesent eget sem eget eros mattis malesuada.</p>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';

export default {
  components: {},
  mixins: [formatData],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      profile: (state) => state.user.profile,
      activeSection: (state) => state.user?.activeSection,
      narrativeText: (state) => state.user?.profile?.narrativeText,
      BSText: (state) => state.user?.profile?.narrativeText?.BS,
      PLText: (state) => state.user?.profile?.narrativeText?.PL,
      SCText: (state) => state.user?.profile?.narrativeText?.SC,
      SUText: (state) => state.user?.profile?.narrativeText?.SU,
    }),
  }
};
</script>
